import { render, staticRenderFns } from "./AcceleratorPostDoc.vue?vue&type=template&id=5b3c0d0c&"
import script from "./AcceleratorPostDoc.vue?vue&type=script&lang=js&"
export * from "./AcceleratorPostDoc.vue?vue&type=script&lang=js&"
import style0 from "./AcceleratorPostDoc.vue?vue&type=style&index=0&id=5b3c0d0c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports